module.exports = __webpack_public_path__ + "img/default.35dc79d8.png";